import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { DateInput } from "../../components/neu/DateInput";
import { useApiError } from "../../hooks/useApiError";

const EMPTY = { name: "", start_date: new Date().toISOString().slice(0, 10), term_months: 12, initial_value: "", annual_rate: "" };

// IFRS 16: recognises the right-of-use asset against the lease liability.
export const LeaseForm = ({ onSaved, onCreate }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [form, setForm] = useState(EMPTY);

  const save = async () => {
    try {
      const res = await onCreate({
        name: form.name,
        start_date: form.start_date,
        term_months: Number(form.term_months),
        initial_value: Number(form.initial_value),
        annual_rate: Number(form.annual_rate || 0),
      });
      toast.success(`${t("acct.ifrs.leaseCreated")} ${res.entry_number}`);
      setForm(EMPTY);
      onSaved();
    } catch (error) {
      toast.error(describe(error));
    }
  };

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  return (
    <NeuCard className="grid gap-3 p-5 sm:grid-cols-6" data-testid="lease-form">
      <NeuInput data-testid="lease-name" placeholder={t("acct.ifrs.leaseName")} value={form.name} onChange={set("name")} />
      <DateInput testId="lease-start" value={form.start_date} onChange={(v) => setForm({ ...form, start_date: v })} />
      <NeuInput data-testid="lease-term" type="number" placeholder={t("acct.ifrs.termMonths")} value={form.term_months} onChange={set("term_months")} />
      <NeuInput data-testid="lease-value" type="number" placeholder={t("acct.ifrs.initialValue")} value={form.initial_value} onChange={set("initial_value")} />
      <NeuInput data-testid="lease-rate" type="number" placeholder={t("acct.ifrs.annualRate")} value={form.annual_rate} onChange={set("annual_rate")} />
      <NeuButton variant="primary" data-testid="lease-save" disabled={!form.name || !form.initial_value} onClick={save}>
        {t("app.save")}
      </NeuButton>
    </NeuCard>
  );
};
